import { render, staticRenderFns } from "./DraftVisits.vue?vue&type=template&id=00c681de&scoped=true"
import script from "./DraftVisits.vue?vue&type=script&lang=ts"
export * from "./DraftVisits.vue?vue&type=script&lang=ts"
import style0 from "./DraftVisits.vue?vue&type=style&index=0&id=00c681de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c681de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c681de')) {
      api.createRecord('00c681de', component.options)
    } else {
      api.reload('00c681de', component.options)
    }
    module.hot.accept("./DraftVisits.vue?vue&type=template&id=00c681de&scoped=true", function () {
      api.rerender('00c681de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Visits/EmptyVisits/DraftVisits.vue"
export default component.exports